import ElementPlus from 'element-plus'
import 'element-plus/theme-chalk/index.css'
import { createApp } from 'vue'
import type { App as AppType } from 'vue'
import App from './App.vue'
import router from "./router/index"

// 创建Vue应用实例并挂载
const app: AppType = createApp(App)
app.use(ElementPlus)
app.use(router)
app.mount('#app')
